// ============================================================================
// post-client-mod -- useCategories Hook
//
// 获取分类列表。
// ============================================================================
import { useState, useEffect, useCallback } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 获取分类列表
 */
export function useCategories() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchCategories = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await getPostApiClient().getCategories();
            setCategories(result);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取分类列表失败';
            setError(message);
            setCategories([]);
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);
    return {
        categories,
        loading,
        error,
        refresh: fetchCategories,
    };
}
//# sourceMappingURL=use-categories.js.map